import GetCampaignFieldMappingByIdRequestModelBase from '../_generated/modelBases/get-campaign-field-mapping-by-id-request-model-base';

export default class GetCampaignFieldMappingByIdRequestModel extends GetCampaignFieldMappingByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
